window.updateRecomPrice = function (selectElement, priceElementId) {
  const selectedOption = selectElement.options[selectElement.selectedIndex];
  const newPrice = selectedOption.getAttribute('data-price');
  const priceDisplay = document.getElementById(priceElementId);

  if (priceDisplay && newPrice) {
    priceDisplay.innerText = newPrice;
  }
};

document.addEventListener('DOMContentLoaded', () => {
  // Buscar los inputs de ordenamiento
  const sortInputs = document.querySelectorAll('input[name^="sort_by"]');

  if (sortInputs.length > 0) {
    // Buscar el formulario que contiene estos inputs (si existe)
    const filterForm = sortInputs[0].closest('form');

    // Si existe un formulario, prevenir que se envíe con Enter o botones
    if (filterForm) {
      filterForm.addEventListener('submit', function(e) {
        e.preventDefault();
      });
    }

    // Lógica de cambio en los inputs
    sortInputs.forEach(input => {
      input.addEventListener('change', function(e) {
        e.preventDefault(); // Detener cualquier acción nativa encadenada
        
        const selectedValue = e.target.value;
        const url = new URL(window.location.href);
        
        // En Shopify, el destacado suele ser 'manual' o un valor vacío
        if (selectedValue === 'manual' || selectedValue === '') {
          url.searchParams.delete('sort_by');
        } else {
          url.searchParams.set('sort_by', selectedValue);
        }
        
        // Forzar la redirección
        window.location.href = url.toString();
      });
    });
  }

  // Close filter dropdown when clicking outside
  document.addEventListener('click', (event) => {
    document.querySelectorAll('details[id^="ucg-filter-details-"]').forEach(detailsElem => {
      if (!detailsElem.contains(event.target)) {
        detailsElem.removeAttribute('open');
      }
    });
  });
});

class UltimaGridForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Listen to the submit event on the custom element itself to catch bubbling events.
    // This avoids issues where the internal <form> might not be parsed yet.
    this.addEventListener('submit', this.onSubmit.bind(this));
  }

  onSubmit(e) {
    e.preventDefault();

    this.form = this.querySelector('form');
    if (!this.form) return;

    const btn = this.form.querySelector('button[type="submit"]');
    const originalText = btn ? btn.innerText : 'Agregar';

    if (btn) {
      btn.innerText = 'Agregando...';
      btn.style.opacity = '0.7';
    }

    let formData = new FormData(this.form);

    // Safely determine the Shopify routes root (supports localized URLs like /es/)
    let rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    if (!rootUrl.endsWith('/')) {
      rootUrl += '/';
    }

    fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      body: formData
    })
      .then(async (response) => {
        const data = await response.json();
        if (!response.ok) {
          throw new Error(data.description || data.message || 'Error al agregar al carrito');
        }
        return data;
      })
      .then(data => {
        if (btn) {
          btn.innerText = '¡Agregado!';
          btn.style.backgroundColor = '#2E7D32';
          btn.style.opacity = '1';
        }

        fetch(window.location.pathname + '?sections=cart-icon-bubble')
          .then(res => res.json())
          .then(parsedState => {
            const bubble = document.getElementById('cart-icon-bubble');
            if (bubble && parsedState['cart-icon-bubble']) {
              bubble.innerHTML = new DOMParser()
                .parseFromString(parsedState['cart-icon-bubble'], 'text/html')
                .querySelector('.shopify-section').innerHTML;
            }
          })
          .catch(err => console.error("Error al actualizar la burbuja:", err));

        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:refresh'));

        setTimeout(() => {
          if (btn) {
            btn.innerText = originalText;
            btn.style.backgroundColor = '';
          }
        }, 2000);
      })
      .catch((error) => {
        console.error('Error al agregar:', error);
        
        const errorsContainer = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors') || document.querySelector('.cart-errors');
        if (errorsContainer) {
          errorsContainer.textContent = error.message;
        }

        if (btn) {
          btn.innerText = 'Sin stock';
          setTimeout(() => {
            btn.innerText = originalText;
            btn.style.opacity = '1';
          }, 2000);
        }
      });
  }
}

if (!customElements.get('ultima-grid-form')) {
  customElements.define('ultima-grid-form', UltimaGridForm);
}